import './navigation.js'
import './skip-link-focus-fix.js'
import $ from 'jquery'

(function () {
  // Load more articles button.
  $('.js-load-more-articles').on('click', function (e) {
    e.preventDefault()

    const $this = $(this)
    const $navigation = $this.closest('.posts-navigation')
    const $container = $this.closest('.site-main')
    const postOffset = $container.children('.hentry').length
    const buttonText = $this.text()
    // console.log(postOffset) // eslint-disable-line no-console

    // Set loading indicator.
    $this.text('Loading...')
    $this.attr('disabled', 'disabled')

    // Request the next set of posts.
    $.post(
      $this.data('admin-url'),
      {
        action: 'modern_load_more_articles',
        // eslint-disable-next-line
        _ajax_nonce: $this.data('ajax-nonce'),
        // eslint-disable-next-line
        query_vars: $this.data('query-vars'),
        offset: postOffset,
        // eslint-disable-next-line
        posts_per_page: $this.data('posts-per-page')
      },
      (data) => {
        // Rollback the load more button text.
        $this.text(buttonText)
        $this.removeAttr('disabled')

        // There more items to show.
        if (data.status === 1) {
          $(data.outputHtml).filter('.hentry').addClass('animated fadeInUp').end().insertBefore($navigation)
        } else {
          // Show the message and fade it out.
          $('<div class="ajaxMessage">').html(data.outputHtml).appendTo($this.parent())

          // Remove the load more button.
          $this.remove()
        }
      }
    )
  // eslint-disable-next-line
  });

  // Contact form.
  // eslint-disable-next-line
  (function () {
    const modMailForms = Array.prototype.slice.call(document.querySelectorAll('.js-modmail-form'))
    if (modMailForms.length) {
      modMailForms.forEach((modMailForm) => {
        const submitButton = modMailForm.querySelector('.js-modmail-form-submit')
        const message = modMailForm.querySelector('.js-message')

        // Submit form.
        modMailForm.addEventListener('submit', function (e) {
          e.preventDefault()
          // eslint-disable-next-line
          if (this.checkValidity() == false) {
            e.stopPropagation()
          } else {
            // Submit the request.

            // Disabled the submit button.
            submitButton.setAttribute('disabled', 'disabled')
            modMailForm.classList.add('submitting')

            // eslint-disable-next-line
            // console.log(modMailForm)
            const fetchUrl = `${modMailForm.getAttribute('data-api-root')}?first_name=&last_name=&email=${modMailForm.email.value}&area=${modMailForm.area.value}`
            // eslint-disable-next-line
            console.log(fetchUrl)

            // eslint-disable-next-line
            fetch(fetchUrl, {
              method: 'POST'
              // eslint-disable-next-line
            }).then((data) => data.json()).then((data) => {
              modMailForm.classList.remove('submitting')

              if (typeof data === 'object') {
                // eslint-disable-next-line
                // console.log(data)
                if (data.error) {
                  message.innerHTML = '<p class="text-danger">Something went wrong. Please double check your inputted data and try again.</p>'
                  // Enable for re-submiting.
                  submitButton.removeAttribute('disabled')
                } else {
                  message.innerHTML = '<p class="text-success">Your subscription to our list has been confirmed.</p>'
                  // Hide the submit button.
                  submitButton.style.display = 'none'
                }
              }
            })
          }

          this.classList.add('was-validated')
        })
      })
    }
    // eslint-disable-next-line
  })();
}())
